import { render, staticRenderFns } from "./AnaglyphSelect.vue?vue&type=template&id=b9ae9926"
import script from "./AnaglyphSelect.vue?vue&type=script&lang=js"
export * from "./AnaglyphSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports